import React, { useMemo } from 'react';
import { pageTitle, text } from '@harmony/enablers/react';
import { useMEMTranslation } from '../utils/text-utils';
import { useIsNPM, useIsRBI, useIsUBI } from '../utils/participation-incentive-type-hook';
import scope from '../providers/harmony-scope/provider-harmony-scope';
import { Button } from '../providers/harmony-scope/lazy-enablers';
import { isStandalone } from '../utils/utils-standalone';
import { useIsFed } from '../utils/utils-fed';
import { CorpNetSuffix } from './ic-guide-link';
import { FED_RBI_GUIDE_LINK, MSX_GUIDE_LINK, FED_UBI_GUIDE_LINK, MSX_UBI_GUIDE_LINK } from '../constants/links';
import { MediaDefaults, useMediaLessThanSize } from '../utils/media-size-hooks';

const Text = scope.forReact(text);
const PageTitle = scope.forReact(pageTitle);

const SellerExperienceHeader: React.FC = () => {
  const { t } = useMEMTranslation();
  const isMediumSizedScreen = useMediaLessThanSize(MediaDefaults.MD);
  const isUBI = useIsUBI();
  const isRBI = useIsRBI();
  const isNPM = useIsNPM();
  const showPageTitle = !isStandalone();
  const isFedVal = useIsFed();
  const rbiLink = useMemo(() => (isFedVal ? FED_RBI_GUIDE_LINK : MSX_GUIDE_LINK), [isFedVal]);
  const ubiLink = useMemo(() => (isFedVal ? FED_UBI_GUIDE_LINK : MSX_UBI_GUIDE_LINK), [isFedVal]);
  const appTitle = t('appTitle');
  return (
    <div style={{ maxWidth: `${isMediumSizedScreen ? '100%' : '50%'}` }}>
      {showPageTitle && (
        <>
          <PageTitle>{appTitle}</PageTitle>
          <br />
        </>
      )}
      <div>
        <Text appearance="metadata">
          {isRBI && t('appTitleTooltipLeadIn2')}
          {isUBI && t('appTitleTooltipLeadIn2UBI')}
          {isNPM && t('appTitleTooltipLeadIn2NPM')}
          &nbsp;
          {(isRBI || isNPM) && (
            <Button href={rbiLink} appearance="link" target="_blank" external>
              <Text appearance="metadata">{t('appTitleTooltipLink2')}</Text>
            </Button>
          )}
          {isNPM && <Text appearance="metadata">, </Text>}
          {(isUBI || isNPM) && (
            <Button href={ubiLink} appearance="link" target="_blank" external>
              <Text appearance="metadata">{t('appTitleTooltipLink2UBI')}</Text>
            </Button>
          )}
          {(isRBI || isUBI || isNPM) && <CorpNetSuffix />}
          &nbsp;
          {t('appTitleTooltipLeadOut2')}
        </Text>
      </div>
    </div>
  );
};

export default SellerExperienceHeader;
